import { adminAuthHttp } from '@/utils/http'

const integrations = {
  getIntegrations: () => adminAuthHttp.get('/integrations'),
  getUserIntegrations: () =>
    adminAuthHttp.get('/integrations/user-integrations'),
  addGoogleCalendarIntegration: () =>
    adminAuthHttp.post('/google-api/calendar'),
  postGoogleCalendarToken: (params) =>
    adminAuthHttp.post('/google-api/save-token', params),
  changeIntegrationStatus: (params) =>
    adminAuthHttp.patch('integrations/toggle/', params),
}

export default integrations
